// extracted by mini-css-extract-plugin
export var postContainer = "CruiseItinerary-module--post-container--51500";
export var preContainer = "CruiseItinerary-module--pre-container--d7547";
export var shorexDisclaimer = "CruiseItinerary-module--shorex-disclaimer--da039";